'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from 'react';
import { useAdminContext } from '@/components/AdminBar/AdminProvider';
import { getClientSideURL } from '@/lib/utils/getURL';
import { Transition } from '@headlessui/react';
import { Drawer, DrawerContent, DrawerDescription, DrawerHeader, DrawerTitle } from '@tallinn-arvudes/ui/atoms/drawer';
import { cn } from '@tallinn-arvudes/ui/utils';
import { LuActivity } from 'react-icons/lu';
import { AdminBarContent, type AdminBarProps } from './AdminBarContent';
export const AdminBar = props => {
  const $ = _c(40);
  const {
    user,
    preview
  } = useAdminContext();
  let onAuthChange;
  let other;
  if ($[0] !== props) {
    ({
      onAuthChange,
      ...other
    } = props);
    $[0] = props;
    $[1] = onAuthChange;
    $[2] = other;
  } else {
    onAuthChange = $[1];
    other = $[2];
  }
  const [open, setOpen] = useState(false);
  let t0;
  let t1;
  if ($[3] !== onAuthChange || $[4] !== user) {
    t0 = () => {
      if (typeof onAuthChange === "function") {
        onAuthChange(user);
      }
    };
    t1 = [user, onAuthChange];
    $[3] = onAuthChange;
    $[4] = user;
    $[5] = t0;
    $[6] = t1;
  } else {
    t0 = $[5];
    t1 = $[6];
  }
  useEffect(t0, t1);
  const show = !!user?.id;
  let t2;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = e => {
      e.stopPropagation();
      setOpen(true);
    };
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== preview) {
    t3 = cn("cursor-pointer transition-opacity duration-300 hover:scale-105 rounded-full h-6 w-6 p-1 flex items-center justify-center opacity-1", "data-[closed]:opacity-0", {
      "bg-green-10": preview
    });
    $[8] = preview;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const t4 = !preview;
  let t5;
  if ($[10] !== preview || $[11] !== t4) {
    t5 = cn({
      "text-semantic-content-brand": preview,
      "text-neutral-0": t4
    });
    $[10] = preview;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t5) {
    t6 = <LuActivity className={t5} />;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t3 || $[16] !== t6) {
    t7 = <div onClick={t2} className={t3}>{t6}</div>;
    $[15] = t3;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== show || $[19] !== t7) {
    t8 = <Transition show={show}>{t7}</Transition>;
    $[18] = show;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      setOpen(false);
    };
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <DrawerHeader className="sr-only"><DrawerTitle>Admini käsuriba</DrawerTitle><DrawerDescription>Administreerimiseks vajalikud lingid</DrawerDescription></DrawerHeader>;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  const t11 = !show;
  let t12;
  if ($[23] !== show || $[24] !== t11) {
    t12 = cn("py-2", {
      flex: show,
      hidden: t11
    });
    $[23] = show;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = getClientSideURL();
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== other || $[28] !== preview || $[29] !== user) {
    t14 = <div className="w-full flex"><AdminBarContent setOpen={setOpen} preview={preview} cmsURL={t13} logo={"T\xF6\xF6lauale"} user={user} {...other} /></div>;
    $[27] = other;
    $[28] = preview;
    $[29] = user;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t12 || $[32] !== t14) {
    t15 = <DrawerContent className="top-0 bottom-auto">{t10}<div className={t12}>{t14}</div></DrawerContent>;
    $[31] = t12;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== open || $[35] !== t15) {
    t16 = <Drawer direction="top" open={open} onClose={t9}>{t15}</Drawer>;
    $[34] = open;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t16 || $[38] !== t8) {
    t17 = <>{t8}{t16}</>;
    $[37] = t16;
    $[38] = t8;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  return t17;
};